.DropdownItem {
  width: 100%;
  display: flex;
  padding: 12px var(--padding-content-xs);
  align-items: center;
  text-align: left;
  color: var(--text-primary);
  transition: all 0.2s ease-in-out;

  &:hover {
    color: var(--brand-secondary);
  }

  &:focus-visible,
  &:active {
    color: var(--brand-tertiary);
  }
}
